import { BaseDto } from '../base.dto';

export class StockMerchantPurchasingDetailsDto extends BaseDto {
  stockId: number;
  merchantId: number;
  supplierId: number;
  inStock: number;
  inTransit: number;
  forecast: number;
  minPar: number;
  maxPar: number;
}